import $ from 'jquery';

const addMaxLength = () => {
    const init = () => {
        textAreaMaxLength();
    }

    const textAreaMaxLength = () => {
        const el = {
            form: '.form-join-our-team',
        }

        if ($(el.form).length === 0) return;

        $(document).ready( () => {
            $(el.form).find('textarea').attr('maxlength', '1500');
        })
    }

    init();
}

export default addMaxLength;